import { render, staticRenderFns } from "./BiletBilgileri.vue?vue&type=template&id=a8fd70b4&scoped=true&"
import script from "./BiletBilgileri.vue?vue&type=script&lang=js&"
export * from "./BiletBilgileri.vue?vue&type=script&lang=js&"
import style0 from "./BiletBilgileri.vue?vue&type=style&index=0&id=a8fd70b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fd70b4",
  null
  
)

export default component.exports